import { useSyncExternalStore } from 'react';
import { ECS } from '../state';

const Score = {
  getSnapshot: () => {
    return collectibleCollided.entities.length;
  },
  subscribe: (callback) => {
    collectibleCollided.onEntityAdded.subscribe(() => {
      callback();
    });
    collectibleCollided.onEntityRemoved.subscribe(() => {
      callback();
    });
  },
};

const collectibleCollided = ECS.world.with('isCollectible', 'isCollided');

export const useScore = () => {
  return useSyncExternalStore(Score.subscribe, Score.getSnapshot);
};
